import React, { useState } from "react";
import { Form, Modal, Row, Col } from "react-bootstrap";
import { ReactComponent as CurrencyUpdateIcon } from "../../../assets/images/CurrencyUpdate.svg";

const UpdateCurrencyRateModal = (props) => {
  const [formData, setFormData] = useState({
    fromCountry: props.fromCountry || "Naira",
    toCountry: props.toCountry || "USD",
    fromRate: props.currentRate || "1380.07",
    toRate: props.currentRate || "1380.07",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleUpdate = () => {
    props.onUpdateRate && props.onUpdateRate(formData);
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
      className="deliva-popup"
    >
      <Modal.Body>
        <div className="modal-content-wrap">
          <div className="text-center">
            <CurrencyUpdateIcon className="img-fluid mb-3" />
            <h4 className="font-weight-normal mb-2 fs-24">
              Update currency rate
            </h4>
            <p className="color-grey mb-4 fs-14">
              Set the exchange rate between currencies
            </p>
          </div>
          <Row>
            <Col md={6}>
              <Form.Group className="custom-form mb-3">
                <Form.Label className="color-head">From country</Form.Label>
                <Form.Control
                  as="select"
                  className="login-input"
                  value={formData.fromCountry}
                  onChange={(e) => handleChange("fromCountry", e.target.value)}
                >
                  <option value="Naira">Naira</option>
                  <option value="USD">USD</option>
                </Form.Control>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="custom-form mb-4">
                <Form.Label className="color-head">Exchange rate</Form.Label>
                <Form.Control
                  type="number"
                  className="login-input"
                  value={formData.fromRate}
                  onChange={(e) => handleChange("fromRate", e.target.value)}
                  step="0.01"
                  min="0"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="custom-form mb-3">
                <Form.Label className="color-head">To country</Form.Label>
                <Form.Control
                  as="select"
                  className="login-input"
                  value={formData.toCountry}
                  onChange={(e) => handleChange("toCountry", e.target.value)}
                >
                  <option value="USD">USD</option>
                  <option value="Naira">Naira</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="custom-form mb-4">
                <Form.Label className="color-head">Exchange rate</Form.Label>
                <Form.Control
                  type="number"
                  className="login-input"
                  value={formData.toRate}
                  onChange={(e) => handleChange("toRate", e.target.value)}
                  step="0.01"
                  min="0"
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="text-center my-2">
            <button
              className="cancel-btn mr-4 px-4 py-2 min-w-80"
              onClick={props.onHide}
            >
              Cancel
            </button>
            <button
              className="b1-btn px-4
              py-2 min-w-80"
              onClick={handleUpdate}
            >
              Update
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateCurrencyRateModal;
